"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShopItem = void 0;
var _mui = require("@ori-ui/mui");
var _productBox = require("@ori/product-box");
const ShopItem = exports.ShopItem = (0, _mui.styled)(_productBox.ProductBox)(({
  theme
}) => ({
  height: '100%',
  minWidth: 165,
  maxWidth: 282,
  [theme.breakpoints.up('lg')]: {
    width: 202
  }
}));
